function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 511.370971c0 282.433829 229.229714 511.3856 512 511.3856s512-228.951771 512-511.3856C1024 228.951771 794.770286 0 512 0S0 228.951771 0 511.370971z",
  fill: "#DE2910",
  "p-id": 2205
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M339.412114 261.558857l49.342172 145.393372h159.568457l-129.287314 94.485942 47.864685 144.237715-127.327085-85.694172-127.488 85.694172 47.879314-144.237715L131.657143 406.9376h159.568457l48.186514-145.378743z m512.073143 289.952914l15.959772 47.0016h51.785142l-42.013257 30.734629 15.637943 46.679771-41.354971-27.648-41.194057 27.648 15.4624-46.665142-41.515886-30.749258h51.6096l15.637943-47.0016z m-34.669714-214.820571l35.328 35.137829 46.240914-22.776686-23.932343 45.860571 34.669715 35.137829-49.152-6.670629-24.751543 43.081143-6.846172-48.610743-50.951314-9.1136 46.3872-22.762057-6.992457-49.283657z m-168.696686-123.099429l46.8992 16.910629L727.259429 190.171429l-2.121143 51.872914 46.08 17.086171-47.381943 14.789486-4.066743 49.444571-26.872686-41.150171-49.9712 13.341257 32.387657-40.330971-27.194514-41.632915z m0 511.458743l46.8992 17.071543 32.241372-40.330971-2.121143 51.872914 46.08 17.071543L723.821714 785.554286l-4.066743 49.590857-26.872685-41.296457-49.9712 13.165714 32.387657-40.330971-27.194514-41.618286z",
  fill: "#FFDC00",
  "p-id": 2206
});

var SvgZh = function SvgZh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1612520021321,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 2204,
    width: 18,
    height: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zh.753a4f77.svg";
export { ForwardRef as ReactComponent };